import { render } from "./secret.html?vue&type=template&id=2c860c93&scoped=true&ts=true"
import script from "./secret.ts?vue&type=script&lang=ts"
export * from "./secret.ts?vue&type=script&lang=ts"

import "./secret.scss?vue&type=style&index=0&id=2c860c93&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c860c93"]])

export default __exports__